export default "./lock.svg"